export default new VueRouter({
    routes: [{
        path: '/',
        name: '',
        meta: {
            title: '首页_山西大易科技股份有限公司'
        }
    }]
})
